import * as types from './types'
/**
 * @function 存储选中门店信息
 * @param commit
 * @param data
 */
export const saveTeachTrainStoreInfo = ({ commit }, data) => {
  commit(types.SET_TEACH_TRAIN_STORE_INFO, data)
}
/**
 * @function 存储导出记录参数
 * @param commit
 * @param data
 */
export const saveExportParamsInfo = ({ commit }, data) => {
  commit(types.SET_EXPORT_PARAMS, data)
}
